
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M1.328 17.492V2.635c0-1.315 1.414-2.129 2.55-1.5l12.571 7.643c1.172.657 1.172 2.35 0 3L3.878 18.992c-1.129.628-2.55-.179-2.55-1.5z"}})])
          )
        }
      }
    